import { colors } from './colors';
import { gridBreakpoints } from './gridBreakpoints';

const theme = {
  colors,
  gridBreakpoints,
};

export default theme;
